import React from 'react';

function TermsIOS() {
  return (
    <div className='max-w-2xl mx-auto p-4'>
      <h2 className='text-3xl font-bold mb-4 mt-4'>
        Terms & Conditions (EULA)
      </h2>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>1. Introduction</h3>
        <p>
          These Terms and Conditions ("Terms") govern your access to and use of
          the Pikchar iOS application ("App"). By downloading, installing, or
          using the App, you agree to be bound by these Terms. If you do not
          agree, please do not use the App.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>2. License to Use</h3>
        <p>
          Pikchar grants you a limited, non-exclusive, non-transferable,
          revocable license to use the App for personal, non-commercial use on
          Apple devices you own or control, in accordance with Apple’s App Store
          Terms of Service.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>3. Restrictions</h3>
        <ul className='list-disc ml-6 mb-8'>
          <li>Reverse engineer, decompile, or modify the App</li>
          <li>Redistribute, sell, rent, or sublicense the App</li>
          <li>Bypass security or subscription mechanisms</li>
          <li>Use the App for unlawful or abusive purposes</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>4. Content Disclaimer</h3>
        <p>
          Pikchar is a video player and streaming platform. We do not host or
          claim ownership of third-party content accessed through the App.
          Availability, legality, and quality of content may vary by region.
          Users are responsible for ensuring compliance with applicable laws.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>5. Subscriptions & Payments</h3>
        <p>
          Some features of the App require a paid subscription.
        </p>
        <ul className='list-disc ml-6 mb-8'>
          <li>Payments are processed via Apple In-App Purchases</li>
          <li>Subscriptions renew automatically unless canceled</li>
          <li>You can manage or cancel subscriptions via Apple ID settings</li>
          <li>No refunds except as required by Apple or applicable law</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>6. Account Responsibility</h3>
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials. Pikchar is not liable for unauthorized access
          caused by your failure to secure your account.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>7. Termination</h3>
        <p>
          We reserve the right to suspend or terminate your access to the App at
          any time if you violate these Terms or misuse the App. Upon
          termination, you must stop using the App.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>8. Disclaimer of Warranties</h3>
        <p>
          The App is provided on an "AS IS" and "AS AVAILABLE" basis. Pikchar
          makes no warranties regarding uninterrupted access, accuracy, or
          reliability of the App or its content.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>9. Limitation of Liability</h3>
        <p>
          To the maximum extent permitted by law, Pikchar shall not be liable
          for any indirect, incidental, or consequential damages arising from
          your use of the App.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>10. Governing Law</h3>
        <p>
          These Terms shall be governed by and interpreted in accordance with
          the laws of India, without regard to conflict of law principles.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>
          11. Apple Acknowledgment
        </h3>
        <p>
          This agreement is between you and Pikchar, not Apple. Apple is not
          responsible for the App or its content and has no obligation to
          provide maintenance or support.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>12. Changes to These Terms</h3>
        <p>
          We may update these Terms from time to time. Continued use of the App
          after changes means you accept the revised Terms.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>13. Contact Us</h3>
        <p>
          If you have any questions regarding these Terms, contact us at:
        </p>
        <p>
          <strong>Email:</strong> pikcharxdynamix@gmail.com
        </p>
      </section>
    </div>
  );
}

export default TermsIOS;
